import classnames from "classnames";
import React, { PureComponent, ReactNode } from "react";
import styled, { css } from "styled-components";

import theme from "../../theme";

export type IIconName =
  | "calendar"
  | "check-box-off"
  | "alerte-cloche"
  | "check"
  | "check-box-on"
  | "chevron-droit"
  | "chevron-gauche"
  | "chevron-haut"
  | "chevron-bas"
  | "chevron-droit-bis"
  | "chevron-gauche-1"
  | "chevron-haut-bis"
  | "chevron-bas-bis"
  | "coeur"
  | "cross"
  | "home"
  | "menu"
  | "radio-button-off"
  | "radio-button-on"
  | "information"
  | "emo-sleep"
  | "plus"
  | "moins"
  | "reglages"
  | "info-ok"
  | "coeur-plein"
  | "repere-1"
  | "recompense"
  | "profile"
  | "loupe"
  | "at"
  | "panier"
  | "panier-noir";

interface IFontelloIconProps {
  className: string;
  color?: string;
  size: number;
}

const colorProp = ({ color }: IFontelloIconProps): string =>
  color || theme.colors.black;

const FontelloIcon = styled.i<IFontelloIconProps>`
  display: flex;
  align-items: center;
  color: ${colorProp};
  ${(props: IFontelloIconProps): string =>
    props.size ? `font-size: ${props.size}px` : ""};
  &::before {
    margin: 0 !important;
  }
`;

const WrapperStyle = css`
  display: flex;
  align-items: center;
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
`;

const Button = styled.button`
  ${WrapperStyle}
`;

const Wrapper = styled.div`
  ${WrapperStyle}
`;

export interface IProps {
  className?: string;
  color?: string;
  disabled?: boolean;
  name: IIconName;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  size: number;
  productsCount?: string;
  children?: string | ReactNode;
  type?: "button" | "submit" | "reset";
}

type IDefaultProps = Required<Pick<IProps, "className">>;

export default class Icon extends PureComponent<IProps, {}, IDefaultProps> {
  public static defaultProps: IDefaultProps = {
    className: "",
  };

  public render(): ReactNode {
    const { className, onClick, disabled, type } = this.props;

    if (onClick) {
      return (
        <Button
          type={type}
          className={className}
          onClick={onClick}
          disabled={disabled}
        >
          {this.renderContent()}
        </Button>
      );
    }

    return <Wrapper className={className}>{this.renderContent()}</Wrapper>;
  }

  public renderContent = (): ReactNode => {
    const { color, name, size, children } = this.props;

    return (
      <>
        {this.renderIcon(name, size, color)}
        {children}
      </>
    );
  };

  public renderIcon(name: IIconName, size: number, color?: string): ReactNode {
    return (
      <FontelloIcon
        size={size}
        color={color}
        className={classnames(`icon-${name}`)}
      />
    );
  }
}
